// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610011904/js/" + chunkId + "." + {"44":"ecd566fa","225":"c3116d92","481":"ec7b0177","486":"b9859a71","770":"fa77179f"}[chunkId] + ".0.4163764129036661.chunk.js";
};